import { ClipboardModule } from '@angular/cdk/clipboard';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { TextFieldModule } from '@angular/cdk/text-field';
import { CommonModule, DatePipe, registerLocaleData } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import localeFrExtra from '@angular/common/locales/extra/fr';
import localeFr from '@angular/common/locales/fr';
import { CUSTOM_ELEMENTS_SCHEMA, DEFAULT_CURRENCY_CODE, LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule, MAT_RIPPLE_GLOBAL_OPTIONS } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule, MAT_SELECT_CONFIG } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { NgxEchartsModule } from 'ngx-echarts';
import { NgxEditorModule } from 'ngx-editor';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { environment } from 'src/environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AvatarComponent } from './components/avatar/avatar.component';

import { LoginComponent } from './components/login/login.component';

import { MyChartComponent } from './components/my-chart/my-chart.component';
import { NavMenuComponent } from './components/nav-menu/nav-menu.component';

import { ResetPasswordComponent } from './components/reset-password/reset-password.component';

import { UserConfigurationComponent } from './components/user-configuration/user-configuration.component';
import { ErrorComponent } from './error.component';
import { ConfigurationGuard } from './tools/configuration.guard';
import { CoreData } from './tools/core-data/core-data';
import { DragDropDirective } from './tools/directive/drag-drop-directive';
import { PreventDoubleClickDirective } from './tools/directive/prevent-double-click.directive';
import { FileUtility } from './tools/file-utility';
import { LoginGuard } from './tools/login-guard';
import { ClientSelectionBoxDialog } from './tools/ui/client-selection-box/client-selection-box';
import { ConfirmBoxDialog } from './tools/ui/confirm-box/confirm-box.component';
import { ContactSelectionBoxDialog } from './tools/ui/contact-selection-box/contact-selection-box';
import { CustomSnackBarComponent } from './tools/ui/custom-snackbar/custom-snackbar.component';
import { FileDisplayComponent } from './tools/ui/file-display/file-display.component';
import { LoadingTask } from './tools/ui/loading-task';

import { UserBoxComponent } from './tools/ui/user-box/user-box.component';

import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { SafeHtmlPipe } from './tools/safe-html-sanitizer';

export const MY_DATE_FORMATS = {
    parse: {
        dateInput: ['dd/MM/yyyy'], // to accept different input styles from user
    },
    display: {
        dateInput: 'dd/MM/yyyy', // display format in input field
        monthYearLabel: 'yyyy MMMM',
        dateA11yLabel: 'MMMM d, y',//'LL',
        monthYearA11yLabel: 'MMMM yyyy'
    },
}
@NgModule({
    declarations: [
        PreventDoubleClickDirective,
        AppComponent,
        ErrorComponent,
        LoginComponent,
        NavMenuComponent,
        CustomSnackBarComponent,
        DragDropDirective,
        ConfirmBoxDialog,
        UserConfigurationComponent,
        UserBoxComponent,
        ClientSelectionBoxDialog,
        ContactSelectionBoxDialog,
        ResetPasswordComponent,
        MyChartComponent,
        MyChartComponent,
        FileDisplayComponent,
        AvatarComponent,
        SafeHtmlPipe,
    ],
    imports: [
        HttpClientModule,
        CommonModule,
        FormsModule,
        BrowserModule,
        ReactiveFormsModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        ClipboardModule,
        MatTableModule,
        MatSnackBarModule,
        MatFormFieldModule,
        MatExpansionModule,
        MatInputModule,
        MatButtonModule,
        MatProgressBarModule,
        MatTooltipModule,
        MatDialogModule,
        MatRadioModule,
        MatIconModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatPaginatorModule,
        MatAutocompleteModule,
        MatSelectModule,
        MatSortModule,
        MatChipsModule,
        MatSlideToggleModule,
        MatButtonToggleModule,
        MatStepperModule,
        MatListModule,
        MatBadgeModule,
        MatMenuModule,
        TextFieldModule,
        ScrollingModule,
        MatCheckboxModule,
        MatProgressSpinnerModule,
        NgCircleProgressModule.forRoot(),
        CalendarModule.forRoot({
            provide: DateAdapter,
            useFactory: adapterFactory,
        }),
        NgxMaterialTimepickerModule,
        NgxEditorModule,
       
    ],
    providers: [
        { provide: LOCALE_ID, useValue: 'fr-FR' },
        // { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
        { provide: MAT_RIPPLE_GLOBAL_OPTIONS, useValue: { disabled: true } },
        { provide: DEFAULT_CURRENCY_CODE, useValue: 'EUR' },
        {
            provide: MAT_SELECT_CONFIG,
            useValue: { overlayPanelClass: environment.isMel ? '' : 'eab-theme' }
        },
        CoreData,
        LoadingTask,
        LoginGuard,
        ConfigurationGuard,
        DatePipe,
        FileUtility
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }

registerLocaleData(localeFr, 'fr', localeFrExtra);
